import React, { Component } from "react";
import _ from 'lodash';
import { List, Button } from 'semantic-ui-react';

import SimpleStorageContract from "./contracts/SimpleStorage.json";
import getWeb3 from "./utils/getWeb3";
import ipfs from './IpfsConfig';
import TxHistoryList from './components/TxHistoryList';

import "./App.css";
import "./css/globalStyle.css";
import "./css/loadingSpinner.css";

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      storageValue: 0,
      web3: null,
      buffer: null,
      ipfsHash: '',
      accounts: null,
      contract: null,
      uploadingIPFS: false,
      uploadingETH: false,
      transactionHash: '',
      gasUsed: '',
      blockNumber: '',
      transactionReceipt: '',
      ethAddress: '',
      preview: '',
    };
  }

  componentDidMount = async () => {
    try {
      // Get network provider and web3 instance.
      const web3 = await getWeb3();

      // Use web3 to get the user's accounts.
      const accounts = await web3.eth.getAccounts();

      // Get the contract instance.
      const networkId = await web3.eth.net.getId();
      const deployedNetwork = SimpleStorageContract.networks[networkId];
      const instance = new web3.eth.Contract(
        SimpleStorageContract.abi,
        deployedNetwork && deployedNetwork.address,
      );
      // now you have the instance of the deployed contract, you can get the address.
      // console.log(instance.events);

      // Set web3, accounts, and contract to the state
      this.setState({ web3, accounts, contract: instance });

      // Get the value from the contract to prove it worked.
      // console.log(instance.methods.get.call(accounts[0]))

    } catch (error) {
      // Catch any errors for any of the above operations.
      alert(
        `Failed to load web3, accounts, or contract. Check console for details.`,
      );
      console.error(error);
    }

    //   document.getElementById("uploadBtn").onchange = function () {
    //     document.getElementById("uploadFile").value = this.value;
    // };
  };


  // function to convert file into buffer
  convertToBuffer = async (reader) => {
    const buffer = await Buffer.from(reader.result);
    this.setState({ buffer });
  };


  getFile = (e) => {
    const { buffer } = this.state;
    e.preventDefault();

    // // User cancelled
    // if (!e.target.files[0]) {
    //   return
    // }
    // set file as chosen file
    const file = e.target.files[0];

    // instantiate a file reader object
    let reader = new window.FileReader();
    // console.log('Empty', reader.readyState);

    // read the contents and represent the data in ArrayBuffer
    reader.readAsArrayBuffer(file);
    // console.log('Loading', reader.readyState);
    // console.log(file.name)

    reader.onloadend = () => this.convertToBuffer(reader);
    this.setState ({
      preview: file.name,
    })
  }


  onIpfsSubmit = async (e) => {
    const { buffer, contract, ipfsHash, uploadingIPFS, transactionHash } = this.state;
    e.preventDefault();

    // bring in user's metamask account address
    const accounts = this.state.accounts;

    console.log('Sending from Metamask account: ' + accounts[0]);
    console.log('contract address', contract.options.address);

    if(buffer !== null) {
      this.setState({
        uploadingIPFS: true,
        // ethAddress: contract.options.address,
        ipfsHash: <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>,
        ethAddress: <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>,
        transactionHash: <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>,
        blockNumber: <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>,
        gasUsed: <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>,
      });
    }else {
      this.setState({
        uploadingIPFS: false,
      });
    }

    try{
      await ipfs.add(buffer, (error, resultIpfsHash) => {
      console.log('ipfs add error', error);
      //setState by setting ipfsHash to ipfsHash[0].hash
      this.setState({ ipfsHash: resultIpfsHash[0].hash });

      //  call Ethereum contract method "sendHash" and .send IPFS hash to etheruem contract
      //  return the transaction hash from the ethereum contract
      contract.methods.set(ipfsHash).send({ from: accounts[0] }, (err, txHash) => {
        // console.log('txHash', err,txHash);
        if(err === null){
        this.setState({
            transactionHash: txHash,
            ethAddress: contract.options.address,
            // uploadingETH: true,
          });
        }else {
          alert(err);
          this.setState({
            transactionHash: 'Transaction rejected...',
            ethAddress: 'Transaction rejected...',
            blockNumber: 'Transaction rejected...',
            gasUsed: 'Transaction rejected...',
            // uploadingETH: false,
          });
        }
      }); // contract

      this.setState({
        uploadingIPFS: false,
        // uploadingETH: false
      });
      // if (transactionHash !== ''){
      //   this.setState({
      //     uploadingETH: true,
      //   });
      // }
      }); // await ipfs.add
    }
    catch(error){
      alert("No chosen file, please select a file to upload");
    }
  }; // onIpfsSubmit

  // fetchTxReceipt = async() => {
  //   const { web3, transactionReceipt, accounts, transactionHash } = this.state;

  //   await this.setState({
  //     blockNumber: 'Uploading to Ethereum from Metamask account: ' + accounts[0],
  //     gasUsed: 'Uploading to Ethereumfrom Metamask account: ' + accounts[0],
  //   });

  //   try{
  //     // get Transaction Receipt on click
  //     // https://web3js.readthedocs.io/en/1.0/web3-eth.html#gettransactionreceipt
  //     await web3.eth.getTransactionReceipt(transactionHash, (err, txReceipt) => {
  //       this.setState({
  //         transactionReceipt: txReceipt,
  //         blockNumber: 'done ',
  //         gasUsed: 'done',
  //       });
  //       // alert(err);
  //       console.log(transactionReceipt);
  //       // console.log(txReceipt.blockNumber)
  //     }); // await for getTransactionReceipt

  //     // console.log(web3.eth.accounts)
  //   } // try
  // catch(error){
  //     alert(error);
  //   } // catch
  // }

  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.transactionHash !== prevState.transactionHash && this.state.uploadingETH === true) {
  //    this.fetchTxReceipt();
  //   }
  // }

  // function for displaying successful transaction information
  getTxReceipt = async () => {
    const { web3, transactionReceipt, accounts, transactionHash } = this.state;

    if(transactionHash !== '') {
    this.setState({
      blockNumber: 'Uploading to Ethereum from Metamask account: ' + accounts[0],
      gasUsed: 'Uploading to Ethereumfrom Metamask account: ' + accounts[0],
    });
  }else {
    this.setState({
      transactionHash: 'No transaction found, please perform a transaction by uploading file',
      blockNumber: 'No transaction found, please perform a transaction by uploading file',
      gasUsed: 'No transaction found, please perform a transaction by uploading file',
    });
  }

    try{
      // get Transaction Receipt on click
      // https://web3js.readthedocs.io/en/1.0/web3-eth.html#gettransactionreceipt
      await web3.eth.getTransactionReceipt(transactionHash, (err, txReceipt) => {
        this.setState({
          transactionReceipt: txReceipt,
        });
        // alert(err);
      }); // await for getTransactionReceipt

      this.setState({
        blockNumber: transactionReceipt.blockNumber,
        gasUsed: transactionReceipt.gasUsed,
      });
      console.log(transactionReceipt)

      // console.log(web3.eth.accounts)

    } // try
  catch(error){
     {transactionHash !== ''
      ? alert("Transaction not yet completed. Please wait...")
      : alert("Error, no transaction found")
  }
    } // catch
  } // onClick


  render() {
    const { ipfsHash, web3, accounts, contract, buffer, uploadingIPFS, uploadingETH, preview } = this.state;
    // console.log('sender address', this.state.accounts)

    if (!this.state.web3) {
      return (
        <div style={{ marginTop: 24 }}>
          <div class="lds-facebook"><div></div><div></div><div></div><div></div></div>
          <h4>Loading Web3, accounts, and contract...</h4>
        </div>
      )
    }
    return (
      <div className="App">
      <h4>Select a file</h4>
        <form onSubmit={this.onIpfsSubmit}>
          {/* <input type='file' onChange={this.getFile} /> */}
          <input type="file" id="myuniqueid" onChange={this.getFile} />
          <label for="myuniqueid" onChange={this.getFile}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17"><path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"></path></svg>
            <span>Choose a file...</span>
          </label>
          <div>{preview}</div>
          <button class="btn" type="submit">
            <span>Upload</span>
          </button>
        </form>

        <div>
          <img src={`https://gateway.ipfs.io/ipfs/${ipfsHash}`} alt='' />
        </div>

        <div>
          {uploadingIPFS === true
            ? <div>
                <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                <div>Uploading file to IPFS...</div>
                <br />
              </div>
            : <div />
          }
        </div>
        {uploadingETH === true
          ? <div>
              <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
              <div>Uploading IPFS hash to Ethereum blockchain</div>
            </div>
          : <div>Link to your content stored in IPFS: <br />
              <a href={`https://gateway.ipfs.io/ipfs/${ipfsHash}`} rel="noopener noreferrer" target="_blank">{`https://gateway.ipfs.io/ipfs/${ipfsHash}`}</a>
            </div>
        }

          <hr />
            <button onClick={this.getTxReceipt} class="btn">
              <span>Get Receipt</span>
            </button>

              <table id="receipt" class="center">
                <thead>
                  <tr>
                    <th>Transaction Receipt Category</th>
                    <th>Values</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>IPFS Hash stored on Ethereum</td>
                    <td>{this.state.ipfsHash}</td>
                  </tr>
                  <tr>
                    <td>Ethereum Contract Address</td>
                    <td>{this.state.ethAddress}</td>
                  </tr>

                  <tr>
                    <td>Transaction Hash </td>
                    <td>{this.state.transactionHash}</td>
                  </tr>

                  <tr>
                    <td>Block Number </td>
                    {this.state.blockNumber !== ''
                    ? <td>{this.state.blockNumber}</td>
                    : <td />
                    }
                  </tr>

                  <tr>
                    <td>Gas Used </td>
                    <td>{this.state.gasUsed}</td>
                  </tr>
                </tbody>
              </table>

        <hr />

        <TxHistoryList
          web3={web3}
          accounts={accounts}
          contract={contract}
        />

      </div>
    );
  }
}

export default App;
